import React, { Component } from "react";
import { withRouter, Link} from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, saveState, deleteState } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { Pagination } from "../Pagination/Pagination";
import { ButtonBack } from "../Button/Back";
import SelectSearch from "../UI/SelectSearch/SelectSearch";
import api from "../../services/api";
import './NaturezaJuridica.css';

const mapDispatchToProps = { saveState, deleteState, exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
		filters: state.filterStore,
	}
}

const initialState = {
	resultadoPesquisa: [],
	nome: "",
	codigo: "",
	esferaAdministrativa: "",
	permiteAutocadastramento: false,
	pesquisaExecutada: false,
	botoesHabilitados : true,
};

export const NaturezaJuridicaList =

// router
withRouter(
// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(
	class extends Component {
	
		constructor(props){
			super(props);
			this.state = initialState;

			this.handleInputChange = this.handleInputChange.bind(this);
			this.pesquisar = this.pesquisar.bind(this);
			this.executaPesquisaPaginada = this.executaPesquisaPaginada.bind(this);
			this.limparPesquisa = this.limparPesquisa.bind(this);	
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					
					<div style={{margin: "10px"}}>
						<h1>Naturezas Jurídicas</h1>
					</div>
					
					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			if (!this.props.location.state?.resetSearch) {
				this.executarPesquisaAnterior();
			}
		}

		renderForm() {
			const { resultadoPesquisa, pesquisaExecutada, codigo, nome, esferaAdministrativa } = this.state;
			const { content } = resultadoPesquisa;
			const user = this.props.user;

			return(
				<div className="container-fluid">
					<div className="br-form">
						<div className="row">
						<div className="col-md">
								<div className="field">
									<div className="input">
										<label htmlFor="codigo">Código:</label>
										<input type="text" name="codigo" 
											value={codigo}  
											onChange={this.handleInputChange} 
											maxLength="100"/>
									</div>
								</div>
							</div>
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label htmlFor="nome">Nome:</label>
										<input type="text" name="nome" 
											value={nome}  
											onChange={this.handleInputChange} 
											maxLength="100"/>
									</div>
								</div>
							</div>
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label htmlFor="consumidora">Esfera Administrativa:</label>
										<SelectSearch
											id="esferaAdministrativa"
											name="esferaAdministrativa"
											options={[{ value: "F", label: 'Federal' }, { value: "E", label: 'Estadual' }, { value: "M", label: 'Municipal' }, { value: "N", label: 'Sem Esfera Administrativa' }]}
											onChange={this.handleInputChange}
											value={esferaAdministrativa}
											includeAllOption={true}
										/>
									</div>
								</div>
							</div>
						</div>
						<div className="actions-button">
							<div className="actions justify-content-start">
								<button type="button" className="button is-primary" onClick={() => this.pesquisar()} disabled={!this.state.botoesHabilitados}>Pesquisar</button>
								<button type="button" className="button is-secondary" onClick={() => this.limparPesquisa()} disabled={!this.state.botoesHabilitados}>Limpar</button>
								<Link to="/natureza-juridica/new"> 
									<button type="button" className="button is-secondary mr-3" disabled={!this.state.botoesHabilitados}>Novo</button>
								</Link>
								<ButtonBack disabled={!this.state.botoesHabilitados} />
							</div>
						</div>
					
						{(content && content.length > 0) &&	
							<div className="br-table">						
								<div className="table">
									<table>
										<thead>
											<tr>
											<th scope="col">Código</th>
											<th scope="col">Nome</th>
											<th scope="col">Permitida no Autocadastramento de Usuários/Órgãos</th>
											<th scope="col">Esfera Administrativa</th>
											<th className="text-center" scope="col">Ações</th>
											</tr>
										</thead>
										
										<tbody>
											{ content.map((naturezaJuridica, index) =>
													<tr key={index} >	
														<td>{naturezaJuridica.id}</td>													
														<td>{naturezaJuridica.nome}</td>
														<td>{naturezaJuridica.permiteAutocadastramento ? 'Sim' : 'Não'}</td>
														<td>{naturezaJuridica.esferaAdministrativa !== null ? naturezaJuridica.esferaAdministrativa[0].toUpperCase() + naturezaJuridica.esferaAdministrativa.substring(1).toLowerCase() : '-'}</td>
														<td className="text-center">
															<div className="actions">
																{ (user.isAdministrador === true || user.isGestorAPI === true) && 
																	<Link to={`/natureza-juridica/edit/${naturezaJuridica.id}`}>
																		<button type="button" disabled={!this.state.botoesHabilitados} title="Editar Natureza Jurídica">
																			<span className="sr-only">Editar</span>
																			<i className="fas fa-edit"></i>
																		</button>
																	</Link>
																}
															</div>
														</td>
													</tr>
												)}
										</tbody>
									</table>
									<Pagination totalPaginas={resultadoPesquisa.totalPages} paginaAtual={resultadoPesquisa.number} onChangePage={this.executaPesquisaPaginada}/>
								</div>
							</div>
						}

						{(pesquisaExecutada && (! content || content.length === 0)) &&
							<div>
								Nenhuma natureza jurídica encontrada com os critérios informados.
							</div>
						}
					</div>
				</div>
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;
			this.setState({[nome]: valor});
		}

		executarPesquisaAnterior() {
			const lastState = this.props.filters[this.props.location.pathname];

			this.setState({
				...initialState,
				...lastState,
				pesquisaExecutada: false,
				resultadoPesquisa: []
			}, () => {
				if (lastState) {
					const lastPage = lastState ? lastState?.resultadoPesquisa?.number : 0;
					this.executaPesquisaPaginada(lastPage);
				}
			});
		}

		pesquisar (e){
			this.props.limpaMensagem();
			this.executaPesquisaPaginada(0);
			if (this.props.location.state?.resetSearch) {
				this.props.history.replace(this.props.location.pathname, {
					...this.props.location.state,
					resetSearch: false,
				  });
			}
		}

		executaPesquisaPaginada (pagina){

			const {codigo, nome, esferaAdministrativa, uf} = this.state;
			const url = '/api/natureza-juridica/paginado';

			const criterioPesquisa = {
				codigo: codigo,
				nome: nome,
				esferaAdministrativa: esferaAdministrativa === "N" ? null : esferaAdministrativa,
				uf: uf,
				pagina: pagina,
			}

			const options = {
				method: 'post',
				url,
				data: criterioPesquisa
			}

			this.props.mostraAguardando();
			api(options)
				.then(response => { 
					this.setState({
						resultadoPesquisa: response.data,
						pesquisaExecutada : true,
					}, () => {
						this.props.saveState(this.state, this.props.location.pathname);
					}) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar as naturezas jurídicas. " + erro)
					this.props.exibeMensagemErro("Erro durante a execução da pesquisa")
				})
				.then(() => {
					this.props.escondeAguardando();
				});
		}

		limparPesquisa(){
			this.setState(initialState, () => {
				this.props.deleteState(this.state, this.props.location.pathname);
			});
		}
	}

) // redux
); // router